export default "__VITE_ASSET__03cd2ef4__"